
class Router {

    constructor(params = {}) {
        this.basePath = params.basePath;
    }

    route(path) {
        const base = this.basePath || '#/';
        const fullPath = `${base}${path}`;
        console.log(`Router::route ${fullPath}`);
        window.location = fullPath;
    }
}

Router.route = (path, basePath) => {
    let router = new Router({
        basePath
    });
    router.route(path);
};

export default Router;